import { render, staticRenderFns } from "./PageForbidden.vue?vue&type=template&id=18d65b2f&scoped=true"
var script = {}
import style0 from "./PageForbidden.vue?vue&type=style&index=0&id=18d65b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d65b2f",
  null
  
)

export default component.exports